import { WizardCarPWAFTNodeOptions } from "components/flexComponents/WizardCarPWA/typings";

// Default addSearchFilter to true even if it is not set
export const isAddCSRFilter = (options: WizardCarPWAFTNodeOptions): boolean =>
  options.addSearchFilter || options.addSearchFilter === undefined;
